<section class="carousel-slide-basic">
  @if (data.title) {
    <p
      *htcReadAloud="
        {
          id: 'activity-title',
          text: data.title | htcMathToSpeech: (sres.lastAddedMapKey | async)
        };
        type: 'NO_PAUSE';
        theme: 'LIGHT'
      "
      data-testid="title">
      <htc-math-text-wrapper
        [attr.aria-label]="
          data.displayText || data.title
            | htcMathToSpeech: (sres.lastAddedMapKey | async)
        "
        [textInput]="data.displayText || data.title"></htc-math-text-wrapper>
    </p>
  }

  @if (data.imgData) {
    <div>
      <htc-expandable-wrapper
        [hidden]="!contentLoaded"
        [imageSrc]="data.imgData.url | cdnSrcBaseUrl"
        [imageAlt]="data.imgData.altText ?? []"
        [isContentLoaded]="contentLoaded">
        <img
          [hidden]="!contentLoaded"
          [src]="data.imgData.url | cdnSrcBaseUrl"
          [alt]="data.imgData.altText | altTextLang"
          (load)="onLoadComplete()"
          (error)="onLoadComplete()"
          data-testid="img" />
      </htc-expandable-wrapper>
      <ngx-skeleton-loader
        [hidden]="contentLoaded"
        appearance="circle"
        [count]="1"
        animation="pulse"
        [theme]="{
          width: '100%',
          height: '5rem',
          'border-radius': '0.3125rem',
          margin: 0
        }"></ngx-skeleton-loader>
    </div>
  }
</section>
